import { createRoute, Outlet, redirect } from '@tanstack/react-router';
import { Route as rootRoute } from 'src/pages/__root';

export const Route = createRoute({
  path: '/',
  getParentRoute: () => rootRoute,
  beforeLoad: async (ctx) => {
    const { auth } = ctx.context;
    if (auth.isFetchingAuthInitialStatus) {
      return true;
    }

    // The Inbox is every user's home base — its Home tab is the
    // chat-agent-driven starting point. Authenticated users always land there.
    if (auth.currentUser) {
      throw redirect({ to: '/inbox' });
    }

    throw redirect({
      to: '/login',
      search: {
        redirect: ctx.location.href,
      },
    });
  },
  component: () => <Outlet />,
});
